import React from 'react';

export default function SectionHead({ label, title }) {
  return (
    <div className="s__head">
      <div className="s__label">{label}</div>
      {title && <h2 className="s__title" dangerouslySetInnerHTML={{ __html: title }} />}
    </div>
  );
}
